import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-mist px-3 py-4 sm:px-6" data-id="element-41" data-mp="1hd1nvzbcra01">
      <div className="mx-auto max-w-2xl" data-id="element-42" data-mp="1hduki7glkj4g">
        <h2 className="text-center font-display text-[1.25rem] font-bold uppercase text-navy sm:text-[1.8rem]" data-id="element-43" data-mp="1ceqaxfprgjdl">
          FREQUENTLY ASKED QUESTIONS
        </h2>
        <ul className="mt-2 space-y-1.5" data-id="element-44" data-mp="2a05x6ghhaahm">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} className="overflow-hidden rounded-md border border-navy/10 bg-white" data-id="element-45" data-mp="203jdvw4svrhp" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-2 px-2.5 py-2 text-left font-heading text-[0.8rem] font-bold text-navy transition-colors duration-150 ease-out hover:text-clinical sm:text-[0.92rem]" data-id="element-46" data-mp="1v5hjif1xc5qx">
                  {f.q}
                  <ChevronDownIcon className={`h-4 w-4 shrink-0 text-clinical transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-47" data-mp="1pkgys5crwdnu" />
                </button>
                {isOpen ? <p id={`faq-${i}`} className="px-2.5 pb-2 text-[0.78rem] leading-[1.35] sm:text-[0.88rem]" data-id="element-48" data-mp="11vxm7dmoxepy">
                    {f.a}
                  </p> : null}
              </li>;
        })}
        </ul>
      </div>
    </section>;
}